import { render, staticRenderFns } from "./invoice-account-detail.vue?vue&type=template&id=0465ffc8"
import script from "./invoice-account-detail.vue?vue&type=script&lang=ts"
export * from "./invoice-account-detail.vue?vue&type=script&lang=ts"
import style0 from "./invoice-account-detail.vue?vue&type=style&index=0&id=0465ffc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports